import React from 'react';
import cn from 'classnames';
import styles from './BindsRow.module.scss';

const BindsRow = ({ size = 'sm', className, ...props }) => (
  <span
    {...props}
    className={cn(styles.root, className, {
      [styles.sm]: size === 'sm',
      [styles.md]: size === 'md',
      [styles.lg]: size === 'lg',
    })}
  />
);

export default BindsRow;
